import { Alert, Button } from '@mui/material';
import { getDeletedNotice } from 'src/utils/deleted-notice';

export interface DeletedRecordAlertProps {
  /** Noun for the record in the notice, e.g. `site` for "This site was deleted on …". */
  entityLabel: string;
  deletedAt?: string | null;
  canRestore: boolean;
  onRestore: () => void;
}

/** Says that a record was deleted and when, with a Restore action for those allowed to restore it. */
export const DeletedRecordAlert = ({
  entityLabel,
  deletedAt,
  canRestore,
  onRestore,
}: DeletedRecordAlertProps) => (
  <Alert
    severity="info"
    action={
      canRestore ? (
        <Button color="inherit" size="small" onClick={onRestore}>
          RESTORE
        </Button>
      ) : null
    }
  >
    {getDeletedNotice(entityLabel, deletedAt)}
  </Alert>
);
